import styled, { css } from "styled-components";

export const paddingCss = css`
  ${(props) => props.pl && `padding-left: ${props.pl}px;`}
  ${(props) => props.pr && `padding-right: ${props.pr}px;`}
  ${(props) => props.pb && `padding-bottom: ${props.pb}px;`}
  ${(props) => props.pt && `padding-top: ${props.pt}px;`}
`;
export const marginCss = css`
  ${(props) => props.ml && `margin-left: ${props.ml}px;`}
  ${(props) => props.mr && `margin-right: ${props.mr}px;`}
  ${(props) => props.mb && `margin-bottom: ${props.mb}px;`}
  ${(props) => props.mt && `margin-top: ${props.mt}px;`}
`;

const Block = styled.div`
  // padding
  ${paddingCss}
  // margin
  ${marginCss}
`;

export const Flex = styled.div`
  display: flex;
  ${paddingCss}
  ${marginCss}
  ${(props) => props.alignItems && `align-items: ${props.alignItems};`}
  ${(props) =>
    props.justifyContent && `justify-content: ${props.justifyContent};`}
  flex-direction: ${({ isColumn }) => (isColumn ? "column" : "row")};
  flex-wrap: ${({ isWrap }) => (isWrap ? "wrap" : "noWrap")};
`;

export const Center = styled(Flex)`
  align-items: center;
  justify-content: center;
`;

export const Between = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`;

export const AlignCenter = styled(Flex)`
  align-items: center;
`;

export const FlexItem = styled.div`
  ${paddingCss}
  ${marginCss}
  flex-grow: ${({ grow = "auto" }) => grow};
  flex-shrink: ${({ shrink = "auto" }) => shrink};
  flex-basis: ${({ basis = "auto" }) => basis};
`;

export const Divider = styled(Block)`
  border-bottom: ${({ dashed, light, height = 1, theme }) =>
    `${height}px ${dashed ? "dashed" : "solid"} ${
      light ? theme.colors.borderLight : theme.colors.border
    }`};
`;

export const Card = styled.div`
  border: 1px solid
    ${({ theme, noBorder }) =>
      noBorder ? "transparent" : theme.colors.border};
  background-color: ${({ theme }) => theme.colors.primaryBg};
  position: relative;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 1rem;
`;

export const StylMain = styled.main`
  padding: 30px 15px;
  margin: auto;
  max-width: 1200px;
`;

export default Block;
